import { Controller } from "@hotwired/stimulus"

// The Zulagen section of the timesheet entry forms: keeps the "2 erfasst" count on the
// header in step with the inputs, and opens a collapsed section when one of its hidden
// inputs fails browser validation (the browser cannot point at a closed <details>).
// Counts like ConfigurableTimeSheetsHelper#allowance_filled?.
export default class extends Controller {
  static targets = ["details", "count", "row"]
  static values = {
    collapsible: Boolean,
    filledOne: String,
    filledOther: String,
    none: String,
  }

  connect() {
    this.refresh()
  }

  refresh() {
    if (!this.hasCountTarget) return

    const filled = this.rowTargets.filter((row) => this.rowFilled(row)).length
    const badge = this.countTarget
    badge.classList.toggle("hidden", filled === 0 && !this.collapsibleValue)
    badge.classList.toggle("bg-green-100", filled > 0)
    badge.classList.toggle("text-green-800", filled > 0)
    badge.classList.toggle("bg-gray-100", filled === 0)
    badge.classList.toggle("text-gray-600", filled === 0)
    badge.textContent = this.label(filled)
  }

  reveal() {
    if (this.hasDetailsTarget) this.detailsTarget.open = true
  }

  rowFilled(row) {
    // An admin override the form does not show (employee forms).
    if (row.dataset.allowancePinned === "true") return true

    return Array.from(row.querySelectorAll("input")).some((input) => {
      if (input.type === "checkbox") return input.checked
      if (input.type !== "number") return false
      if (input.dataset.allowanceOverride === "true") return input.value.trim() !== ""
      return parseFloat(input.value.replace(",", ".")) > 0
    })
  }

  label(filled) {
    if (filled === 0) return this.noneValue
    if (filled === 1) return this.filledOneValue
    return this.filledOtherValue.replace("%{count}", filled)
  }
}
